export default function sort_functionality() {
  if ($('.heimdall-custom-sort-form').length > 0) {
    if ($('.page-description').length > 0)
      $('.sort-container').insertAfter('.page-description');
    else if ($('.term-description').length > 0)
      $('.sort-container').insertAfter('.term-description');
    else
      $('.sort-container').insertAfter('.woocommerce-products-header__title');

    $('.sort-container').click(function() {
      $(this).toggleClass('open');
    });

    var parent = $('.heimdall-custom-sort-form');

    $('.heimdall-list-sort li').each(function() {
      $(this).on('click', function(e) {
        e.stopPropagation();
        var value = $(this).data('value');

        $('.orderby option').each(function() {
          $(this).attr('selected', false);
          if ($(this).val() == value) {
            $('.heimdall-custom-sort-form').val(value);
            $(this).attr('selected', 'selected');
            $('.heimdall-custom-sort-form').submit();
          }
        });
      });
    });
  }
}
